import { render, staticRenderFns } from "./OfferItemProtocolProcessRegister.vue?vue&type=template&id=e5fdc1dc"
import script from "./OfferItemProtocolProcessRegister.vue?vue&type=script&lang=js"
export * from "./OfferItemProtocolProcessRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5fdc1dc')) {
      api.createRecord('e5fdc1dc', component.options)
    } else {
      api.reload('e5fdc1dc', component.options)
    }
    module.hot.accept("./OfferItemProtocolProcessRegister.vue?vue&type=template&id=e5fdc1dc", function () {
      api.rerender('e5fdc1dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/grid/OfferItemProtocolProcessRegister.vue"
export default component.exports